import * as React from "react"
import { cn, decimalPlacesFromStep, isDecimalNumberInput, isValidDecimalInputString, normalizeDecimalInputValue } from "../../lib/utils"

const inputClassName =
    "flex h-10 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50"

const Input = React.forwardRef(({ className, type, step, decimal, onChange, value, ...props }, ref) => {
    const useDecimalInput = isDecimalNumberInput({ type, step, decimal })
    const maxDecimals = decimalPlacesFromStep(step)

    const handleDecimalChange = (e) => {
        const normalized = normalizeDecimalInputValue(e.target.value)
        if (!isValidDecimalInputString(normalized, maxDecimals)) return
        if (e.target.value !== normalized) {
            e.target.value = normalized
        }
        onChange?.(e)
    }

    if (useDecimalInput) {
        return (
            <input
                {...props}
                type="text"
                inputMode="decimal"
                value={value ?? ''}
                className={cn(inputClassName, className)}
                ref={ref}
                onChange={handleDecimalChange}
            />
        )
    }

    return (
        <input
            {...props}
            type={type}
            step={step}
            value={value}
            className={cn(inputClassName, className)}
            ref={ref}
            onChange={onChange}
        />
    )
})
Input.displayName = "Input"

export { Input }
